var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.23 16.267L24 22.497l-6.23-6.23-1.504 1.503L22.497 24l-6.23 6.23 1.503 1.503 6.23-6.23 6.23 6.23 1.503-1.503-6.23-6.23 6.23-6.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.684 36.684c-6.991 6.992-18.371 6.994-25.366 0-6.994-6.994-6.994-18.374 0-25.367A17.878 17.878 0 0 1 24 6.072c4.593 0 9.188 1.748 12.684 5.245 6.994 6.993 6.994 18.373 0 25.367m1.504-26.87c-7.82-7.822-20.55-7.824-28.375 0-7.822 7.822-7.822 20.55 0 28.373 3.912 3.912 9.05 5.867 14.187 5.867 5.139 0 10.276-1.955 14.188-5.867 7.822-7.823 7.822-20.551 0-28.373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedStatus);
export default __webpack_public_path__ + "static/media/rejected-status.d520a080a4bcbc7adb817702e02e6385.svg";
export { ForwardRef as ReactComponent };